import React from "react";
import styled from "styled-components";
import { useTheme, useLoyalty } from "../../../hooks";
import mashupBannerImage from "../../../components/images/mashupBannerImage.jpeg";
import { Button, StyledText } from "../../../components/common/basic";
import { MainHolder, Children } from "../../../components/common/basic";
import { BackButton } from "../../../components/common";
import { useHistory } from "react-router-dom";
import MashupNowButton from "./components/MashupNowButton";

const MashupnDrivePage = () => {
  const history = useHistory();

  const { themeContext, theme } = useTheme();
  const { setCapture } = useLoyalty();

  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];

  return (
    <>
      <MainHolder>
        <Image src={mashupBannerImage} />
        <Gradient>
          <GradientBody>
            <BackButton
              onClick={() => {
                history.goBack();
              }}
            />
            <HeaderContent>
              <ContentContainer>
                <StyledText
                  style={{
                    marginBlockStart: 0,
                    marginBlockEnd: 0,
                    paddingBottom: 10,
                  }}
                  size={26}
                  color={"white"}
                >
                  {"Pulse Mashup"}
                </StyledText>
                <StyledText
                  style={{
                    marginBlockStart: 0,
                    fontFamily: "MTNRegular",
                    marginBlockStart: 0,
                    marginBlockEnd: 0,
                    padding: 0,
                  }}
                  size={13}
                  color={"white"}
                >
                  {
                    "Welcome to Mashup Drive. Buy curated bundles and enjoy the convenience at affordable price."
                  }
                </StyledText>
              </ContentContainer>
            </HeaderContent>
          </GradientBody>
        </Gradient>
        <Children>
          <RulesContainer>
            <StyledText
              style={{
                marginBlockStart: 0,
                marginBlockEnd: 0,
                paddingBottom: 20,
              }}
              size={26}
            >
              {"Mashup"}
            </StyledText>

            {tips.map((note, index) => {
              return (
                <TipsContainer key={index}>
                  <CircleContainer>
                    <Dot color={background} />
                  </CircleContainer>
                  <StyledText
                    style={{ marginBlockStart: 0, fontFamily: "MTNRegular" }}
                  >
                    {note}
                  </StyledText>
                </TipsContainer>
              );
            })}
          </RulesContainer>
          <MashupNowButton />
        </Children>
      </MainHolder>
    </>
  );
};

export default MashupnDrivePage;

const RulesContainer = styled.div`
  margin: 5%;
`;

const Gradient = styled.div`
  width: 100%;
  height: 250px;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.17) 39.58%,
    #000000 100%
  );
  // position: absolute;
  z-index: 1;
  display: grid;
  grid-auto-flow: column;
  align-items: flex-start;
  padding: 5px;
`;

const Image = styled.img`
  height: 250px;
  width: 100%;
  margin: 0;
  position: absolute;
  object-fit: cover;
  object-position: -20px 10%;
`;

const GradientBody = styled.div`
  padding: 5px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 90%;
`;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const HeaderContent = styled.div`
  display: flex;
  align-content: start;
  align-items: flex-end;
  justify-content: flex-start;
  height: 100%;
  width: 100%;
`;

const ContentContainer = styled.div`
  margin-left: 10px;
  margin-right: 10px;
`;

const TipsContainer = styled.div`
  display: flex;
`;

const CircleContainer = styled.div`
  display: flex;
  align-items: flex-start;
  margin-right: 10px;
  margin-top: 5px;
`;

const Dot = styled.div`
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: #ffcc00;
  margin: 0;
  padding: 0;
`;

const tips = [
  "Get data and voice bundles with each purchase ",
  "Different bundles curated including GHc 1, GHc 5, GHc 10 and Flexi bundles",
  "Enjoy social media and stay connected with family and friends",
];
